export const PER_PAGE = 20;
export const NO_SHOW = [
  "CreatedBy",
  "CreatedDateTime",
  "ModifiedBy",
  "ModifiedDateTime",
  "RecId",
  "CompanyId"
];
export const VERSION = "3.1.0";
